import styled, { css } from 'styled-components';
import spacing from '../../../theme/shared/spacing';
import hideVisually from '../../../theme/shared/hideVisually';

var buttonStyle = function buttonStyle() {
  return css(["display:inline-flex;position:relative;padding:0.5rem 1.25rem;text-decoration:none;font-weight:700;font-size:1rem;border-radius:2rem;transition:all 0.5s;min-height:50px;width:100%;justify-content:center;align-items:center;cursor:pointer;", ";@media ", "{width:auto;}"], function (_ref) {
    var color = _ref.color,
        theme = _ref.theme;
    return color ? theme.buttonColors(color) : theme.buttonColors('red');
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.breakpoint('small');
  });
};

var linkStyle = function linkStyle() {
  return css(["text-decoration:none;display:inline;line-height:1.5rem;", ";"], function (_ref3) {
    var type = _ref3.type,
        theme = _ref3.theme,
        underline = _ref3.underline;
    return type ? theme.linkStyles(type, underline) : theme.linkStyles('standard', underline);
  });
};

export var IconWrapper = styled.span.withConfig({
  displayName: "Linkstyle__IconWrapper",
  componentId: "t360tr-0"
})(["margin-left:", ";align-self:center;position:absolute;right:", ";@media ", "{width:auto;right:auto;position:relative;}"], spacing('md'), spacing('m'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint('small');
});
var StyledLink = styled.a.withConfig({
  displayName: "Linkstyle__StyledLink",
  componentId: "t360tr-1"
})(["", ""], function (props) {
  return props.type === 'button' ? buttonStyle : linkStyle;
});
export var HelperText = styled.span.withConfig({
  displayName: "Linkstyle__HelperText",
  componentId: "t360tr-2"
})(["", ";"], hideVisually);
export default StyledLink;